<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Modifier"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="UpdateCommand"
    >
      <!-- account datails tab -->
      <tab-content title="Commande">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Produit</h5>
            <small class="text-muted">
              Information général sur la commande.
            </small>
          </b-col>
          <b-col md="4">
            <b-form-group label="Code" label-for="v-code">
              <b-form-input
                id="v-code"
                placeholder="000001"
                v-model="command.code"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Fournisseur" label-for="item-Supplier">
              <v-select
                id="item-Supplier"
                v-model="Supplier"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                placeholder="Nom du fournisseur"
                :options="suppliers"
                @input="getSupplierDetail(Supplier)"
              >
                <template #list-header>
                  <li
                    v-b-toggle.sidebar-command-add-new-supplier
                    class="
                      add-new-product-header
                      d-flex
                      align-items-center
                      my-50
                    "
                  >
                    <feather-icon icon="PlusIcon" size="16" />
                    <span class="align-middle ml-25"
                      >Ajouter un fournisseur</span
                    >
                  </li>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Nom du dépot" label-for="v-label">
              <b-form-input
                id="v-label"
                placeholder="Nom du dépot"
                v-model="command.warehouse"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Date de livraison" label-for="v-Date">
              <b-form-input
                id="v-Date"
                placeholder="Date de livraison"
                v-model="command.deliveryDate"
                type="date"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="Etat" label="Etat">
              <v-select
                id="Etat"
                v-model="command.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="statusName"
                :options="statusOptions"
                :reduce="(status) => status.label"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Déscription" label-for="v-description">
              <b-form-textarea
                id="v-description"
                placeholder="Cette commande est ..."
                rows="3"
                v-model="command.description"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Détail produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Détail commande</h5>
            <small class="text-muted">Détail sur la commande ...</small>
          </b-col>
          <b-col md="12">
            <b-form
              ref="form"
              :style="{ height: trHeight + 150 }"
              class="repeater-form"
              @submit.prevent="repeateAgain"
            >
              <!-- Row Loop -->
              <b-row
                v-for="(item, index) in items"
                :id="item.id"
                :key="item.id"
                ref="row"
              >
                <!-- Item Name -->
                <b-col md="3">
                  <b-form-group label="Désignation" label-for="item-name">
                    <v-select
                      id="item-name"
                      v-model="item.name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="products"
                      @input="getProductDetail(item)"
                      placeholder="Nom du produit"
                    >
                      <template #list-header>
                        <li
                          v-b-toggle.sidebar-command-add-new-product
                          class="
                            add-new-product-header
                            d-flex
                            align-items-center
                            my-50
                          "
                        >
                          <feather-icon icon="PlusIcon" size="16" />
                          <span class="align-middle ml-25"
                            >Ajouter un produit</span
                          >
                        </li>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <!-- Cost -->
                <b-col md="2">
                  <b-form-group label="Prix unité" label-for="cost">
                    <b-form-input
                      id="cost"
                      type="number"
                      placeholder="32"
                      v-model="item.price"
                      @input="getNewResult(item)"
                    />
                  </b-form-group>
                </b-col>

                <!-- Quantity -->
                <b-col md="2">
                  <b-form-group label="Quantité" label-for="quantity">
                    <b-form-input
                      id="quantity"
                      type="number"
                      placeholder="1"
                      v-model="item.quantity"
                      :max="maxQuantity"
                      @input="quantityChange(item),getNewResult(item)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label="TVA" label-for="v-TVA">
                    <b-form-input
                      id="v-TVA"
                      type="number"
                      placeholder="10"
                      v-model="item.tax"
                      @input="getNewResult(item)"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label-for="v-Remise" label="Remise">
                    <b-form-input
                      id="v-Remise"
                      type="number"
                      placeholder="10"
                      v-model="item.discount"
                     @input="getNewResult(item)"
                    />
                  </b-form-group>
                </b-col>

                <!-- Profession -->
                <b-col lg="1" md="1">
                  <b-form-group label="P.T" label-for="price">
                    <b-form-input
                      id="price"
                      value="32$"
                      plaintext
                      v-model="item.allTaxesIncluded"
                    />
                  </b-form-group>
                </b-col>

                <!-- Remove Button -->
                <b-col lg="1" md="1" class="mb-50">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" class="mr-25" />
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <hr />
                </b-col>
              </b-row>
            </b-form>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="repeateAgain"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>Ajouter un produit</span>
            </b-button>
          </b-col>
        </b-row>
      </tab-content>

      <!-- address -->
      <tab-content title="Prix du produit">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Totale commande</h5>
            <small class="text-muted">Prix, tax et remise du produit.</small>
          </b-col>
           <b-col md="6">
            <b-form-group label="Timbre" label-for="v-Timbre">
              <b-input-group append="$">
                <b-form-input
                  id="v-Timbre"
                  placeholder="10"
                  v-model="command.stampPrice"
                  @input="geTotalNewResult()"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tax" label-for="v-tax">
              <b-input-group append="%">
                <b-form-input
                  id="v-tax"
                  placeholder="10"
                  disabled
                  v-model="command.valueAddedTax"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Remise totale" label-for="v-ptt">
              <b-input-group append="$">
                <b-form-input
                  id="v-ptt"
                  placeholder="1100"
                  disabled
                  v-model="command.totalDiscount"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
                   <b-col md="6">
            <b-form-group label="Prix totale hors tax" label-for="v-pth">
              <b-input-group append="$">
                <b-form-input
                  id="v-pth"
                  placeholder="1000"
                  disabled
                  v-model="command.priceWithoutTaxes"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Prix total avec Tax"
              label-for="v-ptt"
            >
              <b-input-group append="$">
                <b-form-input
                  id="v-ptt"
                  placeholder="1100"
                  disabled
                  v-model="command.allTaxesIncluded"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
            <b-col md="6">
            <b-form-group
              label="Prix total avec Tax et remise"
              label-for="v-ptt"
            >
              <b-input-group append="$">
                <b-form-input
                  id="v-ptt"
                  placeholder="1100"
                  disabled
                  v-model="command.allTaxesIncludedWithDiscount"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- social link -->
      <tab-content title="Image du Facture">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Image Facture</h5>
            <small class="text-muted">Les images des factures</small>
          </b-col>

          <b-col md="12">
            <b-form-group label="Image du produit" label-for="v-image">
              <b-form-input
                id="v-image"
                readonly
                placeholder="Cliquer ici pour ajouter une image"
                @click="openUploadModal()"
              />
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="command.images.length > 0 != ''">
            <b-img
              v-for="(image, index) in command.images"
              :key="index"
              :src="imgCommand(image)"
              fluid
              alt="Responsive image"
            />
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
    <command-sidebar-add-new-product @update-product="getAllProduct" />
    <command-sidebar-add-new-supplier @update-supplier="getAllSupplier" />
  </div>
</template>

<script>
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import commandSidebarAddNewProduct from "./commandSidebarAddNewProduct.vue";
import commandSidebarAddNewSupplier from "./commandSidebarAddNewSupplier.vue";
import { getPriceProduct, getTotalResult } from "@/utils/utils.js";

import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
  VBToggle,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    VBToggle,
    BForm,
    BButton,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    commandSidebarAddNewProduct,
    commandSidebarAddNewSupplier,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [heightTransition],
  data() {
    return {
         items: [
        {
          id: 1,
          name: {},
          price: 0,
          quantity: 1,
          discount: 0,
          valueDiscount: 0,
          tax: 0,
          valueTax: 0,
          allTaxesIncluded: 0,
          allTaxesIncludedWithDiscount: 0,
          quantityType:"Quantity"
        },
      ],
      nextTodoId: 1,
      AllSupplier: [],
      suppliers: [],
      supplier: "",
      allProduct: [],
      products: [],
      maxQuantity: 1,
      totalPriceDiscount: 0,
      command: {
        code: null,
        supplier: "",
        deliveryDate: null,
        status: "",
        description: "",
        products: [
          {
            product: "",
            quantity: 0,
          },
        ],
        priceWithoutTaxes: 0,
        valueAddedTax: 0,
        allTaxesIncluded: 0,
        allTaxesIncludedWithDiscount: 0,
        totalDiscount: 0,
        stampPrice: 0, //timbre
        warehouse: "",
        images: [],
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
      },
      statusOptions: [
        {
          statusName: "En cours",
          label: "in progress",
        },
        {
          statusName: "Payé",
          label: "payed",
        },
        {
          statusName: "Refusé",
          label: "refused",
        },
      ],
    };
  },
  mounted() {
    this.initTrHeight();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getCurrentProductDetail();
    this.getAllProduct();
    this.getAllSupplier();
    this.geTotalNewResult()
  },
  methods: {
    getCurrentProductDetail() {
      axios
        .get(
          "https://management-projects.herokuapp.com/api/purchase-commands/" +
            this.$router.history.current.query.id
        )
        .then((response) => {
          this.command = response.data;
          this.command.allTaxesIncludedWithDiscount=Number.parseFloat(response.data.allTaxesIncluded)-Number.parseFloat(response.data.totalDiscount)
          console.log("get command", response);
          this.supplier = {
            title:
              response.data.supplier.firstName +
              " " +
              response.data.supplier.lastName,
            id: response.data.supplier._id,
          };
          this.items = [];
          response.data.products.forEach((element) => {
            console.log("element", element);
            var item = {
              id:(this.nextTodoId += this.nextTodoId),
                name: {
                title: element.product.label,
                id: element.product._id,
              },
                price: element.product.priceWithoutTaxes,
              quantity: element.quantity,
              discount: element.discount,
              valueDiscount: 0,
              tax: element.valueAddedTax,
              valueTax: 0,
              allTaxesIncluded: 0,
              quantityType:element.quantityType,
              allTaxesIncludedWithDiscount:element.allTaxesIncludedWithDiscount
            };
            this.getNewResult(item)
            this.items.push(item);
            this.getProductDetail(item);
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    getAllSupplier() {
      axios
        .get("https://management-projects.herokuapp.com/api/suppliers")
        .then((response) => {
          console.log('suppliers', response);
          this.AllSupplier = response.data;
          response.data.forEach((element) => {
            this.suppliers.push({
              title: element.firstName + " " + element.lastName,
              id: element._id,
            });
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    getAllProduct() {
      //get all product
      this.products = [];
      axios
        .get("https://management-projects.herokuapp.com/api/products")
        .then((response) => {
          this.allProduct = response.data;
          response.data.forEach((element) => {
            this.products.push({ title: element.label, id: element._id });
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },

    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
          name: {},
          price: 0,
          quantity: 1,
          discount: 0,
          valueDiscount: 0,
          tax: 0,
          valueTax: 0,
          allTaxesIncluded: 0,
          allTaxesIncludedWithDiscount: 0,
          quantityType:"Quantity"
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.geTotalNewResult();
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "dmdd546ps", upload_preset: "jhyzlocs" },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result);
              this.url = result.info.url;
              this.publicId = result.info.public_id;
              this.command.images.push(this.publicId);
            }
          }
        )
        .open();
    },
    // get product details after selection product name
    getProductDetail(item) {
      console.log("test", item);
      var obj = this.allProduct.find((element) => element._id == item.name.id);
      item.price = obj.priceWithoutTaxes;
      item.discount = obj.discount;
      item.tax = obj.valueAddedTax;
      if (obj.quantity) {
        this.maxQuantity = obj.quantity;
      }
      this.geTotalNewResult(item);
    },
    // get Supplier details after selection Supplier name
    getSupplierDetail(supplier) {
      if (supplier && supplier.id) this.command.supplier = supplier.id;
    },


    //get total + verifiy input
    quantityChange(item) {
      if (+item.quantity > +this.maxQuantity) {
        item.quantity = this.maxQuantity;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Quantité maximal est " + this.maxQuantity,
            icon: "EditIcon",
            variant: "info",
          },
        });
      }
      if (item.quantity == 0 || item.quantity == undefined) {
        item.quantity = 1;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Quantité doit être supérieur à 0",
            icon: "EditIcon",
            variant: "info",
          },
        });
      }
    },
    imgCommand(img) {
      return (
        "https://res.cloudinary.com/dmdd546ps/image/upload/v1615691410/" + img
      );
    },

    UpdateCommand() {
      const { createdBy, updatedBy, supplier, ...salesCommand } =
        this.command;
      salesCommand.createdBy = createdBy?._id;
      salesCommand.supplier = supplier?._id;
      salesCommand.updatedBy = JSON.parse(localStorage.getItem("userData"))._id;
      if (this.salesBillNote === false) {
        salesCommand.note = "";
      }
      if (this.salesBillPaymentTerms === false) {
        salesCommand.paymentTerms = "";
      }
      salesCommand.products = [
        ...this.items
          .filter(
            (item) =>
              item.productId != undefined /* && item.name.id == undefined*/
          )
          .map((item) => {
            console.log("item");
            console.log(item);
            return {
              product: item.productId,
              quantity: item.quantity,
              valueAddedTax: item.tax,
              discount: item.discount,
              quantityType: item.quantityType,
              description: item.description,
            };
          }),
        ...this.items
          .filter((item) => item.name.id != undefined)
          .map((item) => {
            console.log("item");
            console.log(item);
            return {
              product: item.name.id,
              quantity: item.quantity,
              valueAddedTax: item.tax,
              discount: item.discount,
              quantityType: item.quantityType,
              description: item.description,
            };
          }),
      ];
      console.log('salesCommand', salesCommand);
      axios
        .put(
          "https://management-projects.herokuapp.com/api/purchase-commands/" +
            this.$router.history.current.query.id,
          salesCommand
        )
        .then((response) => {
          console.log("product", response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Commande bien ajoutée",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/shop/command");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du commande",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },

  // *****************************************************************************
  // get utils fn result
    getNewResult(item){
      var newResult=getPriceProduct(item)
      item.allTaxesIncluded=newResult.priceWithTax
      item.allTaxesIncludedWithDiscount=newResult.priceWithTax-newResult.discount
      item.valueDiscount=newResult.discount
      item.valueTax=newResult.tax
      this.geTotalNewResult()
    },
    async geTotalNewResult(){
      var newTotaleResult = await getTotalResult(this.items)
      this.command.valueAddedTax=newTotaleResult.valueAddedTax
      this.command.totalDiscount=newTotaleResult.valueDiscount
      this.command.priceWithoutTaxes=newTotaleResult.priceWithoutTaxes
      this.command.allTaxesIncluded=newTotaleResult.allTaxesIncluded
      if(this.command.stampPrice){
        this.command.allTaxesIncludedWithDiscount=Number.parseFloat(newTotaleResult.allTaxesIncludedWithDiscount) + Number.parseFloat(this.command.stampPrice)
      }else{
        this.command.allTaxesIncludedWithDiscount=newTotaleResult.allTaxesIncludedWithDiscount
      }
  },


















    // getPercentage(num, per) {
    //   return (num / 100) * per;
    // },
    // // totale price tax, discount, quantity
    // totalePriceCommandDiscountTax(product) {
    //   var totalPriceTax = 0;
    //   if (product.tax != 0 && product.tax) {
    //     product.valueTax = this.getPercentage(product.price, product.tax);
    //     totalPriceTax = product.valueTax + product.price;
    //   }
    //   if (product.discount != 0 && product.discount) {
    //     if (totalPriceTax != 0) {
    //       product.valueDiscount = this.getPercentage(
    //         totalPriceTax,
    //         product.discount
    //       );
    //       return totalPriceTax - product.valueDiscount;
    //     } else {
    //       product.valueDiscount = this.getPercentage(
    //         product.price,
    //         product.discount
    //       );
    //       return product.price - product.valueDiscount;
    //     }
    //   }
    // },
    // totalePriceCommand(productTotale, quantity) {
    //   console.log(quantity);
    //   if (quantity == undefined || quantity == 0) {
    //     return productTotale;
    //   } else if (quantity != 0) {
    //     return productTotale * quantity;
    //   }
    // },





    // totalePrice(item) {
    //   item.allTaxesIncluded =
    //     this.totalePriceCommandDiscountTax(item).toFixed(3);
    //   item.allTaxesIncluded = this.totalePriceCommand(
    //     item.allTaxesIncluded,
    //     item.quantity
    //   );
    //   this.getTotalPrice();
    // },

    // getTotalPrice() {
    //   this.command.priceWithoutTaxes = 0;
    //   this.command.valueAddedTax = 0;
    //   this.command.allTaxesIncluded = 0;
    //   this.command.totalDiscount = 0;
    //   this.items.forEach((item) => {
    //     if (item.quantity == 0 || item.quantity == undefined) {
    //       item.quantity = 1;
    //     }
    //     this.command.priceWithoutTaxes += +item.price * +item.quantity;
    //     this.command.valueAddedTax += +item.valueTax * +item.quantity;
    //     this.command.allTaxesIncluded += +item.allTaxesIncluded;
    //     this.command.totalDiscount += +item.valueDiscount * +item.quantity;
    //   });
    //   this.command.allTaxesIncluded += +this.command.stampPrice;
    // },










  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" >
// .repeater-form {
//   overflow: hidden;
//   transition: 0.35s height;
// }
.add-new-product-header {
  padding: 7px 20px;
  color: #7367f0;
}
</style>
